import { merge } from '../helper';

import prependChild from '../general/prepend/prependChild';

import * as exElement from './element';
import type { IElementConfig } from './element/types';
import * as exIcon from './icon';

// ----------------------------------------------------------------------------

export interface ILabelConfig extends IElementConfig {
    icon?: Record<string, any>;
}

// ----------------------------------------------------------------------------

function create(config: ILabelConfig = {}): Record<string, any> {
    // Default Config
    const defConfig: ILabelConfig = {};

    // Merge
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    //
    const elements: Record<string, any> = {};

    // ------------------------------------------------------------------------

    // Create element (label)
    const elLabel = exElement.create({
        merge: defConfig,
        tag: 'label',
    });
    elements.element = elLabel;

    // ------------------------------------------------------------------------

    // Settings
    settings(elements, defConfig);

    // ------------------------------------------------------------------------

    // Return
    return elements;
}

function settings(elements: Record<string, any>, config: ILabelConfig = {}): void {
    // If using icon
    if (config.icon != null) {
        // Create element (icon)
        const elIcon = exIcon.create(config.icon);
        elements.icon = elIcon;

        // If using icon left
        if (config.icon.left === true) {
            prependChild(elements.element, elIcon);
        }
        // If using icon right
        else {
            elements.element.appendChild(elIcon);
        }
    }
}

// ----------------------------------------------------------------------------

export { create };
